import { DecorationSet, EditorView, PluginValue, ViewUpdate } from "@codemirror/view";


export class CodeEditorHighlightPlugin implements PluginValue {
    private readonly resolver: CodeEditorHighlightResolver;

    public decorations: DecorationSet;

    constructor(view: EditorView, resolver: CodeEditorHighlightResolver) {
        this.resolver = resolver;
        this.resolve(view);
    }

    public update(update: ViewUpdate): void {
        if (!update?.docChanged && !update?.viewportChanged) return;

        this.resolve(update.view);
    }

    private resolve(view: EditorView): void {
        if (!this.resolver) return;

        this.decorations = this.resolver(view);
    }
}

export type CodeEditorHighlightBuilder = (view: EditorView) => CodeEditorHighlightPlugin;

export type CodeEditorHighlightResolver = (view: EditorView) => DecorationSet;